<template>
  <div id="home" class="main">
    <!-- 头部 -->
    <Header index="2" :allcartnum="allcartnum"></Header>
    <div class="content">
      <!--[if lte IE 9]>
        <p class="browserupgrade">
          You are using an <strong>outdated</strong> browser. Please <a
          href="https://browsehappy.com/">upgrade your browser</a> to improve
          your experience and security.
        </p>
      <![endif]-->

      <!-- Add your site or application content here -->

      <!-- prealoder area start -->
      <!-- <div id="loading">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="first_object"></div>
                <div class="object" id="second_object"></div>
                <div class="object" id="third_object"></div>
                </div>
            </div>      
        </div> -->
      <!-- prealoder area end -->
      <!-- page title area start -->

      <section class="p-relative d-flex align-items-center">
        <div class="hidden-md-and-down container" style="max-width: 100%">
          <div class="row">
            <div class="col-xl-12" style="position: relative">
              <div class="swiper-container top-swiper">
                <div class="swiper-wrapper">
                  <!-- <div class="swiper-slide" >
                      
                    </div> -->

                  <div
                    class="page__title swiper-slide"
                    v-for="(item, index) in topbanner"
                    :key="index"
                  >
                    <img
                      class="topimage"
                      :src="allurl + item.image"
                      alt="bigimg"
                    />
                    <!-- <div class="imagenum">{{index+1}}/{{topbanner.length}}</div> -->
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
              <!-- <div class="page__title-inner text-center">
                <h1>Product Details</h1>
                <div  class="page__title-breadcrumb">
                  <nav aria-label="breadcrumb">
                   <ol class="breadcrumb justify-content-center">
                      <li class="breadcrumb-item">
                        <a>Home</a>
                      </li>
                      <li class="breadcrumb-item active" aria-current="page">
                        Product details
                      </li>
                    </ol>
                  </nav>
                </div>

                
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <div class="body-overlay transition-3"></div>
      <!-- extra info area end -->

      <main>
        <!-- shop details area start -->
        <section class="shop__area pb-65">
          <div class="shop__top grey-bg-6 pt-100">
            <div class="container">
              <div class="row">
                <div class="col-xl-6 col-lg-6">
                  <div class="product__modal-box flex hidden-sm-and-down">
                    <div
                      class="product__modal-nav col-md-3 col-xl-3 col-sm-12 col-xs-12 mr-20"
                    >
                      <nav>
                        <div
                          class="nav nav-tabs"
                          id="product-details"
                          role="tablist"
                        >
                          <a
                            v-for="(item, index) in shopbanner"
                            :key="index"
                            class="nav-item nav-link point"
                            @click="chooseshop(index, item.image)"
                            :class="chooses == index ? 'active' : ''"
                            id="pro-one-tab"
                            data-toggle="tab"
                            role="tab"
                            aria-controls="pro-one"
                            aria-selected="true"
                          >
                            <div class="product__nav-img w-img">
                              <img :src="allurl + item.image" alt="" />
                            </div>
                          </a>
                        </div>
                      </nav>
                    </div>

                    <!-- product-details -->
                    <div
                      class="tab-content mb-20 col-cd-9 col-xl-9 col-md-9 col-sm-12 col-xs-12"
                      id="product-detailsContent"
                    >
                      <div
                        class="tab-pane fade show active"
                        id="pro-one"
                        role="tabpanel"
                        aria-labelledby="pro-one-tab"
                      >
                        <div class="product__modal-img product__thumb w-img">
                          <img
                            v-show="showimg"
                            :src="allurl + choosimg"
                            alt="bigimg"
                          />
                          <video
                            v-show="showvideo"
                            playsinline="true"
                            webkit-playsinline="true"
                            style="width: 100%; height: 100%"
                            muted
                            :src="allurl + choosvideo"
                            poster
                            autoplay
                            controls
                          ></video>
                          <!-- <div class="product__sale"> 
                            <span class="new">new</span>
                            <span class="percent">-16%</span>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="product__modal-box hidden-md-and-up">
                    <div
                      class="product__modal-nav col-md-3 col-xl-3 col-sm-12 col-xs-12 mr-20"
                    >
                      <!-- <nav>
                        <el-row :gutter="10">
                          <el-col
                            :xs="6"
                            v-for="(item, index) in shopbanner"
                            :key="index"
                          >
                            <div
                              class="nav nav-tabs col-xs-12"
                              id="product-details"
                              role="tablist"
                            >
                              <a
                                class="col-xs-3 nav-item nav-link point"
                                @click="chooseshop(index, item.image)"
                                :class="chooses == index ? 'active' : ''"
                                id="pro-one-tab"
                                data-toggle="tab"
                                role="tab"
                                aria-controls="pro-one"
                                aria-selected="true"
                              >
                                <div class="product__nav-img w-img">
                                  <img :src="allurl + item.image" alt="" />
                                </div>
                              </a>
                            </div>
                          </el-col>
                        </el-row>
                      </nav> -->
                    </div>

                    <!-- product-details -->
                    <div
                      class="tab-content mb-20 col-cd-9 col-xl-9 col-sm-12 col-xs-12"
                      id="product-detailsContent"
                    >
                      <div
                        class="tab-pane fade show active"
                        id="pro-one"
                        role="tabpanel"
                        aria-labelledby="pro-one-tab"
                      >
                        <div class="product__modal-img product__thumb w-img">
                          <!-- <img
                            v-show="showimg"
                            :src="allurl + choosimg"
                            alt="bigimg"
                          /> -->
                          <div class="swiper-container my-swiper">
                            <div class="swiper-wrapper">
                              <!-- <div class="swiper-slide" >
                                 
                               </div> -->

                              <div
                                class="swiper-slide"
                                v-for="(item, index) in shopbanner"
                                :key="index"
                              >
                                <video
                                  v-if="index == 0"
                                  v-show="showvideo"
                                  muted
                                  x5-video-player-type="h5-page"
                                  style="width: 100%; height: 100%"
                                  :src="allurl + choosvideo"
                                  controls
                                  :poster="allurl + choosimg"
                                ></video>
                                <img :src="allurl + item.image" alt="bigimg" />
                                <div class="imagenum">
                                  {{ index + 1 }}/{{ shopbanner.length }}
                                </div>
                              </div>
                            </div>
                            <div class="swiper-pagination"></div>
                          </div>

                          <!-- <div class="product__sale">
                            <span class="new">new</span>
                            <span class="percent">-16%</span>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                  <div
                    class="product__modal-content product__modal-content-2 text-left"
                  >
                    <h4>
                      <a href="javascript:void(0)">{{ shopgoods.ex_title }}</a>
                    </h4>
                    <div class="rating rating-shop mb-15">
                      <span class="rating-no normal-font ml-10">
                        {{ shopgoods.title }}
                      </span>
                      <span class="review normal-font rating-left"
                        ><a
                          >品牌 Brand: {{ shopgoods.brand_name }}
                          {{
                            shopgoods.brand_ex_tile
                              ? "/" + shopgoods.brand_ex_tile
                              : ""
                          }}</a
                        ></span
                      >
                      <span
                        class="review normal-font rating-left hidden-xs-only"
                      >
                        库存 Stock: {{ shopgoods.numbers }}</span
                      >
                    </div>
                    <div class="rating rating-shop mb-15 hidden-sm-and-up">
                      <span class="review ml-10 normal-font">
                        库存 Stock: {{ shopgoods.numbers }}</span
                      >
                    </div>

                    <!-- <div class="rating rating-shop mb-15">
                      <span class="rating-no ml-10">
                        {{ shopgoods.ex_title }}
                      </span>
                      <span class="review rating-left"
                        ><a>{{ shopgoods.brand_name }}品牌</a></span
                      >
                      <span class="review rating-left"
                        >库存:{{ shopgoods.numbers }}</span
                      >
                    </div> -->
                    <div class="product__price-2 mb-25">
                      <span class="ml-10 normal-font">价格 Price:</span>
                      <span class="ml-10 normal-font"
                        >${{ shopgoods.money }}</span
                      >
                      <span class="old-price normal-font">{{
                        shopgoods.price == 0 ? "" : "$" + shopgoods.price
                      }}</span>
                    </div>
                    <!-- <div class="product__modal-des mb-30">
                                        <p>Claritas est etiam processus dynamicus, qui sequitur mutationem consuetudium lectorum. Mirum est notare quam littera gothica, quam nunc putamus parum claram.</p>
                                    </div> -->
                    <div class="product__modal-form mb-30 text-left">
                      <el-form ref="form" :model="form" label-width="80px">
                        <!-- <div class="product__modal-input size mb-20"  v-for="itemss in spec" :key="itemss.id" >
                          <label>Size <i class="fa fa-star-of-life"></i></label>
                          <el-select placeholder="请选择当前规格" style="width: 90%" v-model="form.sizevalue">
                            <el-option v-for="item in shopspec" :key="item.id" :label="item.title" :value="item.id">
                            </el-option>
                          </el-select>
                          <label>{{itemss.name}} <i class="fa fa-star-of-life"></i></label>
                          <el-select placeholder="请选择当前规格" style="width: 90%" v-model="form.sizevalue">
                            <el-option v-for="item in itemss.content" :key="item.id" :label="item.specname" :value="item.id">
                            </el-option>
                          </el-select>  
                        </div> -->
                        <div
                          class="product__modal-input size mb-20"
                          v-if="shopspec.size != ''"
                        >
                          <label class="ml-10"
                            >Size&nbsp;&nbsp;&nbsp; &nbsp;<i
                              class="fa fa-star-of-life"
                            ></i
                          ></label>
                          <el-select
                            @change="choosespec"
                            placeholder="请选择当前规格"
                            style="width: 90%"
                            v-model="form.sizevalue"
                          >
                            <el-option
                              v-for="item in shopspec.size"
                              :key="item.id"
                              :label="item.title"
                              label-width="50px"
                              :value="item.title"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div
                          class="product__modal-input size mb-20"
                          v-if="shopspec.color != ''"
                        >
                          <label class="ml-10"
                            >Color &nbsp;<i class="fa fa-star-of-life"></i
                          ></label>
                          <el-select
                            @change="choosespec"
                            placeholder="请选择当前规格"
                            style="width: 90%"
                            v-model="form.sizevalue2"
                          >
                            <el-option
                              v-for="item in shopspec.color"
                              :key="item.id"
                              :label="item.title"
                              label-width="50px"
                              :value="item.title"
                            >
                            </el-option>
                          </el-select>
                        </div>
                        <div
                          class="product__modal-required mb-5"
                          v-show="!specchoose && !shopspec"
                        >
                          <span>Repuired Fiields *</span>
                        </div>
                        <div class="pro-quan-area d-sm-flex align-items-center">
                          <div class="normal-font product-quantity-title">
                            <label class="normal-font ml-10"
                              >数量 Quantity</label
                            >
                          </div>
                          <div class="mr-20 mb-20">
                            <el-input-number
                              v-model="form.num"
                              @change="handleChange"
                              :min="1"
                              :max="99"
                              label="描述文字"
                            >
                            </el-input-number>
                          </div>
                          <div class="pro-cart-btn">
                            <a
                              @click="onSubmit"
                              class="point add-cart-btn mb-20"
                              >+ Add to Cart</a
                            >
                          </div>
                        </div>
                      </el-form>
                    </div>
                    <!-- <div class="product__tag mb-25">
                      <span class="ml-10">Category:</span>
                      <span><a class="point">Accessories,</a></span>
                      <span><a class="point">Gaming,</a></span>
                      <span><a class="point">PC Computers,</a></span>
                      <span><a class="point">Ultrabooks</a></span>
                    </div> -->
                    <div class="product__share">
                      <span class="ml-10">分享 Share :</span>
                      <ul>
                        <li>
                          <a
                            href="https://www.facebook.com/runhillAU"
                            target="_blank"
                            class="point"
                            ><i class="fa fa-facebook-f"></i
                          ></a>
                        </li>
                        <li>
                          <a class="point"><i class="fa fa-twitter"></i></a>
                        </li>
                        <!-- <li>
                          <a class="point"><i class="fa fa-behance"></i></a>
                        </li>
                        <li>
                          <a class="point"><i class="fa fa-linkedin"></i></a>
                        </li>
                        <li>
                          <a class="point"><i class="fa fa-youtube"></i></a>
                        </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="specstyle" style="width: 100%; text-align: left">
                  <el-divider></el-divider>
                  <p
                    v-if="shopgoods.weight"
                    class="flex text-left"
                    style="justify-content: center"
                  >
                    <b>重量 Weight</b><b>{{ shopgoods.weight }}</b>
                  </p>
                  <el-divider v-if="shopgoods.weight"></el-divider>
                  <p
                    v-if="shopgoods.size"
                    class="flex text-left"
                    style="justify-content: center"
                  >
                    <b>类型 Type</b><b>{{ shopgoods.size }}</b>
                  </p>
                  <el-divider v-if="shopgoods.size"></el-divider>
                  <!-- <el-divider></el-divider>
                              <p class="flex  text-left"  style="justify-content: center;"><b>weight</b><b>2000</b></p> -->
                </div>
              </div>
            </div>
          </div>
          <div class="shop__bottom">
            <div class="container">
              <div class="row">
                <div class="col-xl-12">
                  <div class="product__details-tab">
                    <!-- <div class="product__details-tab-nav text-center mb-45">
                                        <nav>
                                            <div class="nav nav-tabs justify-content-start justify-content-sm-center" id="pro-details" role="tablist">
                                                <a class="nav-item nav-link active" id="des-tab" data-toggle="tab" href="#des" role="tab" aria-controls="des" aria-selected="true">Description</a>
                                                <a class="nav-item nav-link" id="add-tab" data-toggle="tab" href="#add" role="tab" aria-controls="add" aria-selected="false">Additional Information</a>
                                                <a class="nav-item nav-link" id="review-tab" data-toggle="tab" href="#review" role="tab" aria-controls="review" aria-selected="false">Reviews (4)</a>
                                            </div>
                                        </nav>
                                    </div> -->
                    <div class="tab-content" id="pro-detailsContent">
                      <div
                        class="tab-pane fade show active"
                        id="des"
                        role="tabpanel"
                      >
                        <div
                          class="product__details-des"
                          v-html="shopgoods.content"
                        ></div>
                      </div>
                      <!-- <div class="tab-pane fade" id="add" role="tabpanel">
                                            <div class="product__details-add">
                                                <ul>
                                                    <li><span>Weight</span></li>
                                                    <li><span>.25 KG</span></li>
                                                    <li><span>Dimention</span></li>
                                                    <li><span>62 × 56 × 12 cm</span></li>
                                                    <li><span>Size</span></li>
                                                    <li><span>XL, XXL, LG, SM, MD</span></li>
                                                </ul>
                                            </div>
                                        </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- shop details area end -->
        <section class="product__area pt-60 pb-100">
          <div class="container">
            <div class="row">
              <div class="col-xl-12">
                <div class="section__title-wrapper text-center mb-55">
                  <div class="section__title mb-10">
                    <h2>New</h2>
                  </div>
                  <div class="section__sub-title">
                    <p>新品</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- {{product}} -->
              <div class="">
                <div class="product__slider owl-carousel text-left">
                  <div
                    class="product__item col-xl-3 col-md-4 col-sm-4 col-xs-6"
                    v-for="(item, index) in product"
                    :key="index"
                    @click="viewnews(item.id)"
                  >
                    <div class="product__wrapper mb-60">
                      <div class="product__thumb">
                        <a class="w-img" ref="shopwidth">
                          <img :src="allurl + item.image" alt="product-img" />
                          <!-- <img
                            class="product__thumb-2"
                            :src="allurl + item.image"
                            alt="product-img"
                          /> -->
                        </a>
                      </div>
                      <div class="product__content p-relative">
                        <div class="product__content-inner">
                          <h4>
                            <a class="point">{{ item.ex_title }}</a>
                          </h4>
                          <h4>
                            <a class="point">{{ item.title }}</a>
                          </h4>
                          <div class="product__price transition-3">
                            <span>${{ item.money }}</span>
                            <span class="old-price">{{
                              item.price == item.money || item.price == 0
                                ? ""
                                : "$" + item.price
                            }}</span>
                          </div>
                        </div>
                        <div class="add-cart p-absolute transition-3">
                          <a>+ Add to Cart</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="product__load-btn text-center mt-25">
                  <a class="os-btn os-btn-3">Load More</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- product area end -->
      </main>
      <!-- <div class="btn_wrap hei drop_more">
        <a class="btn_zx" href="javascript:;" date-typeid="24" date-page="1" @click="backlist()">返回列表 &gt;</a>
      </div> -->
    </div>

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>


<script type="text/javascript">
// $('.header .right_icon .icon_msg').on('click',function(){
//   consol.log(123124)
//         $('.mask,.pop_service').fadeIn();
//         $('.pop_service .close,.mask').on('click',function(){
//             $('.mask,.pop_service').fadeOut();
//         })
//     });
/*var p3Swiper = new Swiper('.part3 .swiper-container', {
        autoplay: true,//可选选项，自动滑动
        effect : 'slide',
        pagination: {
            el: '.part3 .swiper-pagination',
            clickable :true,
        }
    })*/
</script>


<script>
import Swiper from "swiper";
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";
import {
  getproductview,
  getgoodstype,
  getindex,
  seach_num,
} from "@/api/index/index";
export default {
  components: { Header, Footer, Swiper },
  name: "home",
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  data() {
    return {
      drawer: false, //1
      // direction: 'rtl',//1导航抽屉
      currentIndex: "",
      teacherIndex: "",
      ishove: true,
      page: 1,
      num: 1,
      limit: 4,
      product: [],
      choosvideo: "",
      newsinfo: [],
      shopbanner: [],
      topbanner: [],
      shopgoods: [],
      specchoose: false,
      onlycolor: false,
      onlysize: false,
      bothspec: false,
      form: {
        sizevalue: "",
        sizevalue2: "",
        num: "",
      },
      loginlock: false,
      spec: [
        {
          id: 1,
          name: "size",
          content: [
            { specname: "xl", id: 1 },
            { specname: "xxl", specid: 2 },
          ],
        },
        {
          id: 1,
          name: "color",
          content: [
            { specname: "red", specid: 1 },
            { specname: "blue", specid: 2 },
          ],
        },
      ],
      shopspec: [],
      video: "",
      videolock: false,
      banner: "",
      showvideo: false,
      showimg: false,
      imgurl: "https://admin.cdhyxyl.com/",
      activeBtn: 2,
      clickIndex: 0,
      newsid: "",
      choosimg: "",
      dianlock: false,
      chooses: 0,
      allcartnum: 0,
      selffetch: [],
      leftIcon: require("../../assets/left.png"),
      rightIcon: require("../../assets/right-active.png"),
    };
  },
  mounted() {
    // let video = document.getElementsByClassName("video");
    // video.play();
    var newSwiper = new Swiper(".my-swiper", {
      initialSlide: 0,
      loop: true, // 循环模式选项
      // direction: 'vertical', //竖直方向
      slidesPerView: 1,
      autoplay: true,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    var topSwiper = new Swiper(".top-swiper", {
      initialSlide: 0,
      loop: true, // 循环模式选项
      // direction: 'vertical', //竖直方向
      slidesPerView: 1,
      autoplay: true,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    this.getinfo();
  },
  onshow() {
    this.getinfo();
  },
  created() {},
  methods: {
    getinfo(id) {
      if (sessionStorage.getItem("cartnum")) {
        this.allcartnum = JSON.parse(sessionStorage.getItem("cartnum"));
      }

      if (sessionStorage.getItem("selffetch")) {
        this.selffetch = sessionStorage.getItem("selffetch");
      }

      getproductview(this.$route.query.id).then((res) => {
        this.shopbanner = res.banner;
        this.topbanner = res.goods_image;
        if (this.topbanner.length > 1) {
          this.dianlock = true;
        }
        this.shopgoods = res.goods;
        this.shopspec = res.spec;
        this.choosvideo = this.shopgoods.video;
        this.choosimg = this.shopbanner[0].image;
        this.video = res.goods.video;
        console.log(this.video);
        if (this.shopspec.size == "" && this.shopspec.color == "") {
          this.specchoose = true;
        } else if (this.shopspec.size == "") {
          this.onlycolor = true;
        } else if (this.shopspec.color == "") {
          this.onlysize = true;
        } else if (this.shopspec.size && this.shopspec.color) {
          this.bothspec = true;
        }
        if (this.video) {
          this.showvideo = true;
        } else {
          this.showimg = true;
        }
      });
      getindex().then((res) => {
        this.product = res.hot;
      });
      getgoodstype().then((res) => {
        this.banner = res.banner[0].image;
      });
    },
    onSubmit() {
      var nowcart = [];
      var that = this;

      if (this.shopgoods.numbers < this.form.num) {
        this.msgError("库存不足");
        return;
      }
      if (sessionStorage.getItem("cart")) {
        nowcart = JSON.parse(sessionStorage.getItem("cart"));
      }
      if (sessionStorage.getItem("login")) {
        this.loginlock = JSON.parse(sessionStorage.getItem("login"));
      }

      if (!this.loginlock) {
        this.msgError("当前未登录");
        // setTimeout(() => {
        //      that.$router.push({ path: "/login"})
        //   }, 2000);

        return;
      }
      if (this.selffetch && this.selffetch.indexOf(this.shopgoods.id) == -1) {
        // this.msgError("该商品位置相关信息可咨询超市工作人员");
        this.$message({
          dangerouslyUseHTMLString: true,
          message:
            "<p>该商品位置相关信息可咨询超市工作人员</p><p>Please consult the supermarket staff for information about the location of this product</p>",
          type: "error",
        });
        return;
      }

      // console.log(nowcart);
      // this.form.sizevalue;
      if (this.specchoose == true) {
        console.log(this.shopgoods.id);

        var shoop = [];
        var nowview = {};
        nowview["goods_id"] = this.shopgoods.id;
        nowview["title"] = this.shopgoods.title;
        nowview["ex_title"] = this.shopgoods.ex_title;
        nowview["uuid"] = this.shopgoods.uuid;
        if (this.form.sizevalue) {
          nowview["spec"] = this.form.sizevalue;
          // if(this.form.sizevalue2){
          //   console.log('有')
          //   nowview["spec"] = this.form.sizevalue + "," + this.form.sizevalue2
          // }
        } else if (this.form.sizevalue2) {
          nowview["spec"] = this.form.sizevalue2;
          // if(this.form.sizevalue){
          //   nowview["spec"] = this.form.sizevalue + "," + this.form.sizevalue2
          // }
        } else if (!this.form.sizevalue && !this.form.sizevalue) {
          nowview["spec"] = "";
        } else {
          nowview["spec"] = this.form.sizevalue + "," + this.form.sizevalue2;
        }
        // nowview["spec"] = this.form.sizevalue
        //   ? this.form.sizevalue + "," + this.form.sizevalue2
        //   : this.form.sizevalue + "" + this.form.sizevalue2;
        nowview["spec1"] = this.form.sizevalue;
        nowview["spec2"] = this.form.sizevalue2;
        nowview["num"] = this.form.num;

        nowview["money"] = this.shopgoods.money;
        nowview["thumb"] = this.shopgoods.thumb;
        if (nowcart) {
          // console.log(nowview, "不重复");
          // for (var i = 0; i <= nowcart.length - 1; i++) {
          //   console.log(nowcart);
          //   //判断如果与原产品ID和规格重复就在原数据添加数量
          //   if (nowcart[i].goods_id == this.shopgoods.id && nowcart[i].spec == this.form.sizevalue) {
          //     console.log("重复产品", nowcart[i].spec);
          //     console.log("重复产品", this.form.sizevalue);

          //     nowcart[i].num = this.form.num + nowcart[i].num;
          //     shoop=nowcart
          //     console.log(nowcart, "重复最终数据");
          //      sessionStorage.setItem("cart", JSON.stringify(shoop));
          //   } else {//如果同一规格产品 则新加产品
          //     console.log(nowview, "不重复");
          //     console.log(nowcart);
          //     nowcart.push(nowview);
          //     console.log(nowcart, "不重复最终数据");
          //     shoop=nowcart;
          //     sessionStorage.setItem("cart", JSON.stringify(shoop));
          //   }
          // }
          let cartType = false;
          nowcart.forEach((item) => {
            console.log(item, this.form);
            if (
              item.goods_id == this.shopgoods.id &&
              item.spec1 == this.form.sizevalue &&
              item.spec2 == this.form.sizevalue2
            ) {
              item.num += this.form.num;
              cartType = true;
            }
          });
          if (!cartType) {
            nowcart.push(nowview);
            console.log(nowview, "重复");
          }
          sessionStorage.setItem("cart", JSON.stringify(nowcart));
          sessionStorage.setItem("cart", JSON.stringify(nowcart));
          sessionStorage.setItem("cartnum", nowcart.length);
          this.allcartnum = JSON.parse(sessionStorage.getItem("cartnum"));
          this.$message({
            dangerouslyUseHTMLString: true,
            message:
              "<p>成功加入到购物车</p><p>Successfully add to shopping cart</p>",
            type: "success",
          });
        } else {
          
          shoop.push(nowview);
          console.log(nowview, "不重复");
          sessionStorage.setItem("cart", JSON.stringify(shoop));
          sessionStorage.setItem("cartnum", shoop.length);
          this.allcartnum = JSON.parse(sessionStorage.getItem("cartnum"));
          this.$message({
            dangerouslyUseHTMLString: true,
            message:
              "<p>成功加入到购物车</p><p>Successfully add to shopping cart</p>",
            type: "success",
          });
        }

        //  console.log(nowview)
        //  consloe.log(nowcart)

        // console.log(shoop)
      } else {
        this.msgError("请选择规格");
      }
      // console.log('submit!');
    },
    choosespec(res) {
      console.log(res);
      if (this.onlycolor && this.form.sizevalue2) {
        this.specchoose = true;
        console.log("只有颜色");
      } else if (this.onlysize && this.form.sizevalue) {
        this.specchoose = true;
        console.log("只有尺寸");
      } else if (this.bothspec && this.form.sizevalue && this.form.sizevalue2) {
        this.specchoose = true;
        console.log("都有");
      }
    },
    viewnews(id) {
      // this.$router.push({ name: "newsview" });
      console.log(this.$router.history.current.name);

      this.$router.push({ path: "/productview", query: { id } });
      this.getinfo(id);
    },
    backlist() {
      this.$router.push({ path: "/shop" });
    },
    //计数器
    handleChange(value) {
      console.log(value);
    },
    chooseshop(index, image) {
      if (index == 0) {
        this.showvideo = true;
        this.showimg = false;
      } else {
        this.showimg = true;
        this.showvideo = false;
      }
      this.chooses = index;
      this.choosimg = image;
      console.log(this.chooses);
    },

    moreTap() {
      this.$router.go(-1);
    },
    opendr() {
      console.log(this.sizevalue);
    },
    closeDrawer() {
      console.log(1);
    },
    handleClose(done) {
      console.log(123123);
      done();
    },
    changestyle(index) {
      this.currentIndex = index;
    },
    originstyle() {
      this.currentIndex = "";
    },
    clicktap(index) {
      this.clickIndex = index;
    },
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();
        console.log(val);
        this.activeBtn = 2;
        this.rightIcon = require("../../assets/right-active.png");
        this.leftIcon = require("../../assets/left.png");
      } else {
        this.$refs.cardShow.prev();
        console.log(val);
        this.activeBtn = 1;
        this.leftIcon = require("../../assets/left-active.png");
        this.rightIcon = require("../../assets/right.png");
      }
    },
    changehandle(currentIndex, originIndex) {
      console.log(currentIndex, originIndex);
    },
    // 移入事件
    delHandleMouseEnter(index) {
      this.teacherIndex = index;
    },
    // 移出
    delHandleMouseleave() {
      this.teacherIndex = "";
    },
  },
};
</script>

<style scoped lang='less'>
/*!
*/
#pro-one .w-img {
  height: auto !important;
}

a:link,
a:active,
a:visited {
  // color: #444;
  // text-decoration: none;
}
.normal-font {
  font-size: 14px !important;
  color: #201f1f !important;
  font-weight: 500 !important;
}
.readv {
  width: 100%;
  height: 600px;
  overflow: hidden;
  background: #000;
  margin-top: 20px;
}
.product__nav-img {
  height: 115px;
}
.readc section .rich_pages {
  width: 100%;
}
.content {
  background: #f1f1f1;
}
// .sale__area{background:#f1f1f1}
.product__area .product__slider > .col-xs-6 {
  width: 50%;
}
.product__item {
  padding: 5px;
  margin: 0;
}

.product__content {
  padding: 5px 10px;
}
.product__wrapper {
  background: #fff;
  padding-bottom: 30px;
  border-radius: 5px;
  overflow: hidden;
}
.section__title h2 {
  background: #f1f1f1;
}
.product__wrapper .w-img {
  width: 100%;
}
@media screen and (max-width: 1450px) {
  .readbox {
    width: 1000px;
  }

  .wrapper.xxyx .part .con_wrap {
    width: 73%;
    min-width: 1200px;
  }
}
@media screen and (max-width: 1140px) {
  .pt-100 {
    padding-top: 50px;
  }
}

//max小于，min大于
@media screen and (max-width: 480px) {
  // .w-img{height:400px}
  .product__wrapper {
    margin: 0;
  }
  .product__nav-img {
    height: 72px;
  }
  .normal-font {
    font-size: 12px !important;
    color: #201f1f !important;
    font-weight: 500 !important;
  }
  .product__modal-content-2 h4 {
    font-size: 22px;
  }

  .product__content-inner a {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 12px;
  }
  .product__wrapper .w-img {
    height: 200px;
  }
  .rating-left {
    padding-left: 15px;
    margin-left: 15px;
  }
  .pt-100 {
    padding-top: 30px;
  }
  .readbox {
    width: 100%;
  }

  .wrapper.xxyx .part .con_wrap {
    width: 100%;
    min-width: 100%;
  }
}
.specstyle {
  padding: 5%;
}
.specstyle b {
  width: 50%;
}

.rating-shop {
  text-align: left;
}

.product__modal-input::after {
  content: "";
}

.rating.rating-shop span {
  // font-size: 1rem;
}

#product-details {
  // width: 60%;
}

.owl-carousel {
  display: flex;
  flex-wrap: wrap;
}
a {
  cursor: pointer;
}
.el-input-number {
  width: 140px;
}
.my-swiper {
  height: 98vw;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 0px 3px 1px rgba(215, 215, 215, 0.35);
}
.my-slide {
  border-bottom: 1px solid #efefef;
  line-height: 100px;
  text-align: center;
}
.swiper-slide {
  position: relative;
}
.imagenum {
  position: absolute;
  right: 10%;
  bottom: 10%;
  z-index: 100000;
  background: #fff;
  border-radius: 10px;
  padding: 0 10px;
}
.topimage {
  height: 100%;
  width: 100%;
}
.page__title-inner {
  position: absolute;
  right: 50%;
  bottom: 50%;
  transform: translate(50%, 50%);
  z-index: 10;
}
.product__thumb .w-img img:hover {
  transform: scale(1.1);
}
// .product__thumb{border:1px solid #bc8246 }
</style>
<style >
.swiper-pagination-bullet-active {
  background: #201f1f !important;
}
</style>




// WEBPACK FOOTER //
// src/views/productview/productview.vue